import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '分类导航',
    links: [
      { label: '跳转方法', path: '/category/tiaozhuan-fangfa' },
      { label: '最新地址', path: '/category/zuixin-dizhi' },
      { label: '访问教程', path: '/category/fangwen-jiaocheng' },
      { label: '常见问题', path: '/category/changjian-wenti' },
      { label: '平台资讯', path: '/category/pingtai-zixun' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '信誉展示', path: '/about#reputation' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="container-site py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                TV
              </span>
              <span className="text-lg font-bold font-heading text-background-50">鲍鱼tv跳转</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              鲍鱼tv跳转导航——提供最新、最全的鲍鱼tv跳转入口与使用教程。
              收藏本站，随时获取最新访问地址与实用指南。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{group.title}</h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 鲍鱼tv跳转导航. 本站为第三方导航网站，与鲍鱼tv官方无关。
          </p>
          <p className="text-xs text-background-500">
            鲍鱼tv跳转 | 鲍鱼tv跳转入口 | 鲍鱼tv最新地址
          </p>
        </div>
      </div>
    </footer>
  );
}